import { Card, CardContent, CardHeader, Grid, Stack, Typography } from "@mui/material"
import DashboardLayout from "../layoutcontainers/DashboardLayout"
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BASEURL from "./Utils/Baseurl";
import MaterialButton from "../components/MaterialButton";
import { DesignationContext } from "../context/designationcontext";
import { useNavigate } from "react-router-dom";

const PermissionApproval = ()=>{

    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");

    const{designation}  = useContext(DesignationContext)



    const getpermission = `
      

    query GetPermissionById($id: ID!) {
     permissionById(id: $id) {
       id
       user {
         id
         username
       }
       permissionOn
       permissionFrom
       permissionTill
       reason
       balanceHours
       teamApproval
       hrApproval
       status
       createdAt
     }
   }
        
    
        `
    const nav = useNavigate()

    const handleclose =()=>{

        nav('/permission')

    }

        const ApproveSubmit =(status)=>{
        
             if(designation.value=="Team List"){

                const approvebymanager =`
                 mutation ApprovePermissionManager($id: String!, $status: String!) {
  PermissionApprovalManager(id: $id, status: $status) {
    permissionApprovalManager {
      id
      teamApproval
      hrApproval
      status
    }
  }
}
                
                `

                 

                const Approval = async ()=>{
                    try{
                        const response =   await axios.post(
                            BASEURL,
                            {
                              query: approvebymanager,
                              variables: { 
                              id:id,
                              status:status



                               },
                            },
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                            }
                          );
            
                               
            
                            
                      nav("/permission")
            
                    }
                    catch(error){
                        console.error(error,"err")
                    }
            
                }
            
                Approval()


             }
             if(designation.value=='HR List'){

                const ApproveHr =`
                   mutation ApprovePermissionHR($id: String!, $status: String!) {
             PermissionApprovalHR(id: $id, status: $status) {
           permissionApprovalHR {
              id
            teamApproval
          hrApproval
            status
              }
        }
            }
                
                `


                const Approval = async ()=>{
                    try{
                        const response =   await axios.post(
                            BASEURL,
                            {
                              query: ApproveHr,
                              variables: { 
                              id:id,
                              status:status



                               },
                            },
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                            }
                          );
            
                               
            
                            
                      nav("/permission")
            
                    }
                    catch(error){
                        console.error(error,"err")
                    }
            
                }
            
                Approval()



             }
             


        }
    const[employeeData,setemployedata] = useState({})
        useEffect(()=>{
            if(id){
           
            const fetchpermission = async ()=>{
            try{
                const response =   await axios.post(
                    BASEURL,
                    {
                      query: getpermission,
                      variables: { id },
                    },
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    }
                  );
    

                    setemployedata( response.data.data.permissionById)
    
                       
    
                    
              
    
            }
            catch(error){
                console.error(error,"err")
            }

        }

        fetchpermission()
    } 
    
    
        },[id])

    return(

        <DashboardLayout>
        <Card sx={{ padding: 2, boxShadow: 3 }}>
          <CardHeader
            title={
              <Stack direction="column" spacing={0}>
                <Typography variant="h5" fontWeight="bold" textAlign="center">
                  Permission Details
                </Typography>
              </Stack>
            }
          />
          <CardContent>
            <Grid   container spacing={1} marginLeft={"4%"}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                <Stack spacing={2}>
                  <Typography variant="h6">
                    <strong>User Name:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                      {employeeData.user?.username?.toUpperCase()}
                    </span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>Permission On:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                      {employeeData?.permissionOn}
                    </span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>Permission From:</strong>{" "}
                    <span style={{ color: "#67748E" }}>{employeeData.permissionFrom}</span>
                  </Typography>
                  <Typography variant="h6">
                    <strong> Permission Till:</strong>{" "}
                    <span style={{ color: "#67748E" }}>{employeeData.permissionTill}</span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>Balance Hours:</strong>{" "}
                    <span style={{ color: "#67748E" }}>{employeeData.balanceHours}</span>
                  </Typography>
                </Stack>
              </Grid>
      
              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Stack spacing={2}>
                  <Typography variant="h6">
                    <strong>Reason:</strong>{" "}
                    <span style={{ color: "#67748E" }}>{employeeData.reason}</span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>Team Approval:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval}
                    </span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>HR Approval:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                    {employeeData?.hrApproval}
                    </span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>Status:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                    {employeeData?.status}
      
                      </span>
                  </Typography>
                  <Typography variant="h6">
                    <strong>Created AT:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                    {employeeData?.createdAt}
      
                      </span>
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
      
            {/* Close and Action Buttons */}
            <Grid container spacing={2} justifyContent="center" marginTop={4}>
              { (
                <>
                  <Grid item>
                    <MaterialButton
                      variant="contained"
                      color="primary"
                      onClick={() => ApproveSubmit("approved")}
                    >
                      Approve
                    </MaterialButton>
                  </Grid>
                  <Grid item>
                    <MaterialButton
                      variant="contained"
                      color="secondary"
                      onClick={() => ApproveSubmit("rejected")}
                    >
                      Reject
                    </MaterialButton>
                  </Grid>
                
                </>
              )}
               <Grid item>
                    <MaterialButton
                      variant="contained"
                      color="dark"
                      onClick={() => handleclose()}
                    >
                      Close
                    </MaterialButton>
                  </Grid>
            </Grid>
            
          </CardContent>
        </Card>
      </DashboardLayout>



    )



    


}

export default PermissionApproval